var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "text-center py-0 pl-0 pr-0 pb-0", attrs: { fluid: "" } },
    [
      _c("div", [
        _c("img", {
          staticStyle: { "vertical-align": "middle" },
          attrs: { width: "100%", src: _vm.bannerImage }
        })
      ]),
      _c("div", { staticClass: "text-center main-title" }, [
        _c("h1", [_vm._v(_vm._s(_vm.title))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }